/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpRespHeroCarousel_viewer$ref = any;
export type PdpRespHeroCarousel_viewer = {
    readonly isRequestMoreImagesEnabled: boolean | null;
    readonly " $refType": PdpRespHeroCarousel_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespHeroCarousel_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isRequestMoreImagesEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "REQUEST_MORE_IMAGES"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"REQUEST_MORE_IMAGES\")"
        }
    ]
} as any);
(node as any).hash = 'ab3cafa173d6bac3db4a623edec508eb';
export default node;
